import { Link, useParams } from 'react-router-dom';
import { Button } from '../components/ui';

export function NotFound() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="min-h-screen grid place-items-center px-6 bg-bg">
      <div className="text-center max-w-sm">
        <p className="text-5xl font-semibold text-fg-subtle">404</p>
        <h1 className="text-xl font-semibold mt-3">No encontramos esta página</h1>
        <p className="text-fg-muted mt-2 text-[15px]">
          Puede que el enlace esté desactualizado o que la dirección tenga un error.
        </p>
        <Link to={slug ? `/${slug}` : '/'} className="inline-block mt-6">
          <Button variant="outline">Volver al inicio</Button>
        </Link>
      </div>
    </div>
  );
}
